<emob-modal-card>
  <emob-modal-card-header>
    {{ 'ALERTING.UNMUTE_STATION' | translate }}
  </emob-modal-card-header>
  <emob-modal-card-content class="unmute-content" [compact]="true">
    <eop-grid-list [columns]="1">
      <div class="body-m">{{ 'ALERTING.UNMUTE_STATION_DESC' | translate }}</div>
      <div class="station-detail-content">
        <div class="body-s station-detail-title">
          {{ 'GLOBAL.CHARGING_STATION' | translate }}
        </div>
        <div class="icon-with-text">
          <eop-icon
            [identifier]="'ic-charging-station'"
            [vaylensFont]="true"
            [size]="IconSize.SMALL"
            [color]="IconColor.NORMAL"></eop-icon>
          <div class="body-m status-label">
            {{ modalData.stationName }}
          </div>
        </div>
        <div class="icon-with-text small">
          <eop-icon
            [identifier]="'location-outlined'"
            [vaylensFont]="true"
            [size]="IconSize.MINI"
            [color]="IconColor.NORMAL"></eop-icon>
          <div class="body-s status-label">
            {{ modalData.street | empty }}, {{ modalData | location: LocationTypes.LINE2 | empty }},
            {{ modalData.country ? ('GLOBAL.' + modalData.country | translate) : '' }}
          </div>
        </div>
      </div>
    </eop-grid-list>
  </emob-modal-card-content>
  <emob-modal-card-footer class="unmute-footer">
    <button
      id="cancelButton"
      eopButton
      [color]="ButtonColor.TERTIARY"
      [attr.data-test]="'cancel-button'"
      (click)="onClose()">
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button id="confirmButton" eopButton [attr.data-test]="'confirm-button'" (click)="onConfirm()">
      {{ 'ALERTING.UNMUTE_STATION' | translate }}
    </button>
  </emob-modal-card-footer>
</emob-modal-card>
